import React, { PureComponent } from 'react';
import { InvestorSection } from './InvestorSection';

// import Typography from '../widgets/Typography/Typography';
import BlockFiles from '../widgets/Typography/BlockFiles';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

export class InvestorsTabs extends PureComponent {
  render() {
    const general = this.props.general;

    // const bonds = this.props.bonds;
    const files = this.props.files;

    return (
      <Tabs>
        <TabList>
          {/* <Tab>ОБЛИГАЦИИ</Tab> */}
          <Tab>ОБЩИЕ СВЕДЕНИЯ</Tab>
          <Tab>УСТАВ И ВНУТРЕННИЕ ДОКУМЕНТЫ</Tab>
          <Tab>ЭМИССИОННЫЕ ДОКУМЕНТЫ</Tab>
          <Tab>ПРОЧИЕ ДОКУМЕНТЫ</Tab>
        </TabList>
        {/* <TabPanel>
          <div className="tab-container">
            <div className="left">
              <Typography content={bonds}/>
            </div>
            <div className="right">
              <BlockFiles content={files.bonds} />
            </div>
          </div>
        </TabPanel> */}
        <TabPanel>
          <div className="tab-container">
            <div className="left">
              {general.map((item, index) =>
                <InvestorSection key={index} content={item} />
              )}
            </div>
            {/* <div className="right">
              <BlockFiles content={files.general} />
            </div> */}
          </div>
        </TabPanel>
        <TabPanel>
          <div className="message-container">
            <BlockFiles content={files.general} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="message-container">
            <BlockFiles content={files.bonds} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="message-container">
            <BlockFiles content={files.message} />
          </div>
        </TabPanel>
      </Tabs>
    );
  }
}

export default InvestorsTabs;



// WEBPACK FOOTER //
// ./src/components/Investors/InvestorsTabs.js